import theme from './Theme'
// Config for firebase
export const prodConfigO = {
    apiKey: "AIzaSyBmhF_G7XPpI5wnhZbR7ICRiNmq6yeuJSM",
    authDomain: "scorpion-core.firebaseapp.com",
    databaseURL: "https://scorpion-core.firebaseio.com",
    projectId: "scorpion-core",
    storageBucket: "scorpion-core.appspot.com",
    messagingSenderId: "540405935686"
}

export const devConfigO = {
    apiKey: "AIzaSyBmhF_G7XPpI5wnhZbR7ICRiNmq6yeuJSM",
    authDomain: "scorpion-core.firebaseapp.com",
    databaseURL: "https://scorpion-core.firebaseio.com",
    projectId: "scorpion-core",
    storageBucket: "scorpion-core.appspot.com",
    messagingSenderId: "540405935686"
};
//novo

export const prodConfig = {
    apiKey: "AIzaSyBzvVAhQ7zFyR7HooQ4gY-_5imfNCJfTMk",
    authDomain: "okdsprojects.firebaseapp.com",
    databaseURL: "https://okdsprojects.firebaseio.com",
    projectId: "okdsprojects",
    storageBucket: "okdsprojects.appspot.com",
    messagingSenderId: "666454994396"
}

export const devConfig = {
    apiKey: "AIzaSyBzvVAhQ7zFyR7HooQ4gY-_5imfNCJfTMk",
    authDomain: "okdsprojects.firebaseapp.com",
    databaseURL: "https://okdsprojects.firebaseio.com",
    projectId: "okdsprojects",
    storageBucket: "okdsprojects.appspot.com",
    messagingSenderId: "666454994396"
};
//undefined, private, public
export const defaultRotas = "private"
export const aplicationName = "OK Projects"

export const themeMaterial = theme


// WEBPACK FOOTER //
// ./src/ConfigAplication.js